import React from 'react';
import PropTypes from 'prop-types';
import withSounds from 'containers/withSounds';
import TextButton from 'components/TextButton';
import { videoShape } from 'utils/shapes';
import { htmlDecode } from 'utils/web';
import './VideoListItem.css';

const TextButtonWithSounds = withSounds({ mouseEnterSound: true })(TextButton);

function VideoListItem({ video, onVideoClick, nowPlaying }) {
  const handleVideoClick = () => {
    if (onVideoClick) {
      onVideoClick(video);
    }
  };
  const title = htmlDecode(video.title);

  return (
    <li className="video-list-item">
      <TextButtonWithSounds
        className={`video-list-item-wrapper ${nowPlaying ? 'now-playing' : ''}`}
        title={title}
        onClick={handleVideoClick}
      >
        <img
          src={`https://i.ytimg.com/vi/${video.videoId}/hqdefault.jpg`}
          alt={title}
        />
      </TextButtonWithSounds>
    </li>
  );
}

VideoListItem.propTypes = {
  video: videoShape,
  onVideoClick: PropTypes.func,
  nowPlaying: PropTypes.bool
};

export default VideoListItem;
